import { useState } from "react";
import { Switch, Route, useLocation, useHistory } from "react-router-dom";
import useWindowSize from "react-use/lib/useWindowSize";
import Confetti from "react-confetti";
import { Snackbar, Alert } from "@material-ui/core";
import { RootState, RootDispatch } from "./model";
import { useRematch } from "./utils/useRematch";
import discord from "./assets/discord.svg";
import twitter from "./assets/twitter.svg";
import logo from "./assets/logo-white.svg";
import petsLogo from "./assets/pets-logo.svg";
import footer from "./assets/footer.svg";
import Index from "./pages/index";
import Pets from "./pages/pets";
import RolePlus from "./pages/role+";
import Gallery from "./pages/gallery";

import "swiper/swiper.less";
import "./App.less";
import { useEffect } from "react";

const mapState = (state: RootState) => ({
  ...state.main,
  loading: state.loading,
});

const mapDispatch = (dispatch: RootDispatch) => ({
  ...dispatch.main,
});

function App() {
  const [{ isMainNet, alertState, party }, { setFields, closeAlert, init }] =
    useRematch(mapState, mapDispatch);

  let location = useLocation();
  let history = useHistory();

  const LinkPage = (path: string) => {
    history.push(path);
  };
  const { width, height } = useWindowSize();

  useEffect(() => {
    init();
  }, []);
  return (
    <div className="App">
      <Snackbar
        color="secondary"
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={isMainNet === false}
      >
        <Alert severity="warning" sx={{ width: "100%" }}>
          You are not connect to the Ethereum network!
        </Alert>
      </Snackbar>
      <Snackbar
        color="secondary"
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={alertState.open}
        autoHideDuration={6000}
        onClose={closeAlert}
      >
        <Alert severity={alertState.type} onClose={closeAlert}>
          {alertState.content}
        </Alert>
      </Snackbar>
      <Confetti
        width={width}
        height={height}
        numberOfPieces={party ? 800 : 0}
        tweenFunction={(t, b, _c, d) => {
          var c = _c - b;
          return (c * t) / d + b;
        }}
        tweenDuration={8000}
        recycle={false}
        onConfettiComplete={(confetti) => {
          setFields({
            party: false,
          });
          confetti!.reset();
        }}
      />
      {/* <canvas id="confetti"></canvas> */}
      <div className="logo">
        <div className="left">
          <img
            src={petsLogo}
            width="100%"
            className={`${location.pathname === "/pets" ? "active-route" : ""}`}
            alt=""
            onClick={() => {
              LinkPage("/pets");
            }}
          />
          <img
            src={logo}
            width="100%"
            className={`${location.pathname === "/" ? "active-route" : ""}`}
            alt=""
            onClick={() => {
              LinkPage("/");
            }}
          />
        </div>
        <div className="right">
          <div className="media">
            <a
              href="https://discord.gg/cxZke5vW"
              target="_blank"
              rel="noreferrer"
            >
              <img src={discord} width="100%" alt="" />
              Discord
            </a>
          </div>
          <div className="media">
            <a
              href="https://twitter.com/role4metaverse"
              target="_blank"
              rel="noreferrer"
            >
              <img src={twitter} width="100%" alt="" />
              Twitter
            </a>
          </div>
        </div>
      </div>
      <Switch>
        <Route path="/gallery" component={Gallery} />
        <Route path="/role+" component={RolePlus} />
        <Route path="/pets" component={Pets} />
        <Route path="/" component={Index} />
      </Switch>
      <div className="footer">
        <div className="footer-logo">
          <img src={footer} alt="" width="100%" />
        </div>
        <div className="infos">© 2021 ROLEDAO</div>
      </div>
    </div>
  );
}

export default App;
